<template>
    <div class="vivo-registration-container">
      <el-card class="container-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span class="card-title"><i class="el-icon-tickets"></i> 报名列表</span>
        </div>
  
        <!-- 搜索表单 -->
        <el-form
          :inline="true"
          :model="searchForm"
          class="search-form compact-form"
          label-position="right"
          label-width="70px"
        >
          <div class="search-fields">
            <el-form-item label="姓名" size="small">
              <el-input
                v-model="searchForm.name"
                placeholder="姓名"
                clearable
                class="compact-input"
              ></el-input>
            </el-form-item>
  
            <el-form-item label="电话" size="small">
              <el-input
                v-model="searchForm.tel"
                placeholder="电话"
                clearable
                class="compact-input"
              ></el-input>
            </el-form-item>
  
            <el-form-item label="地址" size="small">
              <el-input
                v-model="searchForm.address"
                placeholder="地址"
                clearable
                class="compact-input"
              ></el-input>
            </el-form-item>
  
            <el-form-item label="创建时间" size="small" class="time-range-item">
              <el-date-picker
                v-model="searchForm.timeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                size="small"
              ></el-date-picker>
            </el-form-item>
  
           
          </div>
        </el-form>
        <div class="form-buttons" style="margin-left: 60px;">
              <el-button
                type="primary"
                size="small"
                @click="handleSearch"
                icon="el-icon-search"
                plain
              >
                搜索
              </el-button>
              <el-button
                size="small"
                @click="resetSearch"
                icon="el-icon-refresh"
                plain
              >
                重置
              </el-button>
              <el-button
                type="success"
                size="small"
                @click="exportData"
                icon="el-icon-download"
                plain
              >
                导出Excel
              </el-button>
            </div>
  
        <!-- 数据表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          v-loading="loading"
          element-loading-text="数据加载中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
          class="data-table"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="100"
            align="center"
            header-align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            width="140"
            align="center"
            header-align="center"
          ></el-table-column>
          <el-table-column
            prop="tel"
            label="电话"
            width="140"
            align="center"
            header-align="center"
          ></el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            align="center"
            min-width="160"
            show-overflow-tooltip
            header-align="center"
          ></el-table-column>
          <el-table-column
            prop="url"
            label="URL"
            min-width="200"
            align="center"
            show-overflow-tooltip
            header-align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="180"
            align="center"
            header-align="center"
          ></el-table-column>
          <el-table-column
            label="操作"
            width="240"
            align="center"
            header-align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
                plain
              >
                编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                plain
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            background
            small
          ></el-pagination>
        </div>
  
        <el-dialog
          title="编辑报名信息"
          :visible.sync="dialogVisible"
          width="50%"
          @close="handleDialogClose"
        >
          <Edit
            ref="editForm"
            :row-data="currentRow"
            @submit="handleSubmit"
            @cancel="dialogVisible = false"
          />
        </el-dialog>
      </el-card>
    </div>
  </template>
  
  
  <script>
  import {get, post, exportFile} from '@/until/controlRequest'
  import Edit from "./components/Edit.vue";
  
  export default {
    name: 'VivoRegistrationList',
    components: {
      Edit
    },
    data() {
      return {
        clientIdentifier: 'vivomanju',
        searchForm: {
          name: '',
          tel: '',
          address: '',
          timeRange: []
        },
        tableData: [],
        loading: false,
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        dialogVisible: false,
        currentRow: {}
      };
    },
    created() {
      this.fetchPage();
    },
    methods: {
      fetchPage() {
        this.loading = true;
        const params = {
          clientIdentifier: this.clientIdentifier,
          name: this.searchForm.name,
          tel: this.searchForm.tel,
          address: this.searchForm.address,
          page: this.pagination.current,
          pageSize: this.pagination.size,
        };
  
        if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
          params.startTime = this.searchForm.timeRange[0];
          params.endTime = this.searchForm.timeRange[1];
        }
  
        get('/vivoRegistration/page', params)
          .then(data => {
            this.tableData = data.records
            this.pagination.total = data.total
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = false
          })
      },
      exportData() {
        const params = {
          clientIdentifier: this.clientIdentifier,
          name: this.searchForm.name,
          tel: this.searchForm.tel,
          address: this.searchForm.address
        };
  
        if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
          params.startTime = this.searchForm.timeRange[0];
          params.endTime = this.searchForm.timeRange[1];
        }
        exportFile(
          '/vivoRegistration/export',
          params,
          '报名列表_' + Date.now() + '.xlsx'
        );
      },
      handleSearch() {
        this.pagination.current = 1;
        this.fetchPage();
      },
      handleEdit(row) {
        this.currentRow = {...row};
        this.dialogVisible = true;
      },
  
      handleSubmit(formData) {
        post('/vivoRegistration/update', formData)
          .then(() => {
            this.$message.success('修改成功');
            this.dialogVisible = false;
            this.fetchPage(); // 刷新列表
          })
          .catch(() => {
            this.$message.error('修改失败');
          });
      },
  
      handleDialogClose() {
        this.$refs.editForm.cancel();
      },
      handleDelete(row) {
        this.$confirm(`确定要删除吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          post(`/vivoRegistration/delete/${row.id}`)
            .then(() => {
              this.$message.success('删除成功');
              this.fetchPage(); // 刷新列表
            })
            .catch(() => {
              this.$message.error('删除失败');
            });
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },
      resetSearch() {
        this.searchForm = {
          name: '',
          tel: '',
          address: '',
          timeRange: []
        };
        this.handleSearch();
      },
      handleSizeChange(val) {
        this.pagination.size = val;
        this.fetchPage();
      },
      handleCurrentChange(val) {
        this.pagination.current = val;
        this.fetchPage();
      },
    }
  };
  </script>
  
  <style scoped>
  .vivo-registration-container {
    padding: 10px;
    background-color: #f5f7fa;
  }
  
  .container-card {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  
  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
  
  .card-actions {
    float: right;
  }
  
  .search-form {
    margin: 0 auto;
  }
  
  .compact-form >>> .el-form-item {
    margin-bottom: 10px;
  }
  
  .compact-form >>> .el-form-item__label {
    padding-right: 5px;
    font-size: 12px;
  }
  
  .compact-input >>> .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  
  .form-buttons {
    text-align: right;
  }
  
  .data-table {
    margin-top: 15px;
    font-size: 13px;
    text-align: center;
  }
  
  .el-table .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .pagination-container {
    margin-top: 15px;
    text-align: right;
  }
  
  .el-table >>> .el-table__body tr:hover > td {
    background-color: #f5f7fa !important;
  }
  
  .el-button {
    margin-left: 8px;
  }
  
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }
  .search-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.search-fields .el-form-item {
  margin-bottom: 10px;
}

.time-range-item {
  flex: 1;
  min-width: 300px;
}

.form-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

  </style>
  


// WEBPACK FOOTER //
// src/components/kehu/vivoRegistration/vivomanju.vue